var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
    fill: "#E8F1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3571 15C20.5714 15 20.7857 15.2143 20.7857 15.4286V16.2857C20.7857 16.5268 20.5714 16.7143 20.3571 16.7143H16.5V20.5714C16.5 20.8125 16.2857 21 16.0714 21H15.2143C14.9732 21 14.7857 20.8125 14.7857 20.5714V16.7143H10.9286C10.6875 16.7143 10.5 16.5268 10.5 16.2857V15.4286C10.5 15.2143 10.6875 15 10.9286 15H14.7857V11.1429C14.7857 10.9286 14.9732 10.7143 15.2143 10.7143H16.0714C16.2857 10.7143 16.5 10.9286 16.5 11.1429V15H20.3571Z",
    fill: "#0085E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusButton);
export default __webpack_public_path__ + "static/media/plus-button.b22a86df.svg";
export { ForwardRef as ReactComponent };